import React from "react";
import { Bike, Cpu, Heart } from "lucide-react";
import DetailSheet from "../session/generate/DetailSheet";
import { ItemRow } from "../profile/ProfileParts";

/**
 * Settings' one Add in Devices: pick what you're adding, a Khronos Timer
 * (linked with the code on its screen) or Bluetooth gear (paired with this
 * browser). The Bluetooth choices start pairing from this tap, which the
 * browser needs to show its device picker.
 */
const AddDeviceSheet = ({ open, onClose, canLinkTimer, bluetooth, onLinkTimer, onPairEquipment, onPairStrap }) => {
  const noBluetooth = "Needs Chrome or Edge on Android or a computer";
  return (
    <DetailSheet open={open} onOpenChange={(o) => !o && onClose()} title="Add a device">
      <div className="divide-y divide-border overflow-hidden rounded-xl border border-border bg-card">
        <ItemRow
          Icon={Cpu}
          title="Khronos Timer"
          detail={canLinkTimer ? "The wall display. Link it with the code on its screen." : "Sign in to link a timer"}
          disabled={!canLinkTimer}
          onClick={onLinkTimer}
        />
        <ItemRow
          Icon={Bike}
          title="Bike or rower"
          detail={bluetooth ? "A smart bike, or a Concept2 PM5" : noBluetooth}
          disabled={!bluetooth}
          onClick={onPairEquipment}
        />
        <ItemRow
          Icon={Heart}
          title="Heart-rate strap"
          detail={bluetooth ? "For live heart rate and your zones" : noBluetooth}
          disabled={!bluetooth}
          onClick={onPairStrap}
        />
      </div>
    </DetailSheet>
  );
};

export default AddDeviceSheet;
